<template>
  <div>
  <v-card class="card--flex-toolbar">
    <v-card-title class="blue-grey lighten-5">
      <h2>Relatórios</h2>
    </v-card-title>
    <v-card-text>
      <v-form v-model="valid">
        <v-container grid-list-md>
          <!-- DATA INICIAL -->
          <v-layout row wrap>
            <v-flex xs12 sm2>
              <v-menu
                :close-on-content-click="false"
                v-model="menuDataInicial"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="item.dataInicial"
                  label="Data Inicial"
                  :rules="rules.dataInicial"
                  readonly
                ></v-text-field>
                <v-date-picker
                  v-model="dataPickerInicial"
                  no-title
                  locale="pt-br"
                  @input="menuDataInicial = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>

            <!-- DATA FINAL -->
            <v-flex xs12 sm2>
              <v-menu
                :close-on-content-click="false"
                v-model="menuDataFinal"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="item.dataFinal"
                  label="Data Final"
                  :rules="rules.dataFinal"
                  readonly
                ></v-text-field>
                <v-date-picker
                  v-model="dataPickerFinal"
                  no-title
                  locale="pt-br"
                  @input="menuDataFinal = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
              <v-flex xs12 sm4>
                <v-select
                  v-model="item.tipo"
                  :items="tipos"
                  label="Tipo de relatório"
                  item-value="text"
                  item-text="text"
                  :rules="rules.tipo"
                  required
                ></v-select>
              </v-flex>
              <v-flex xs12 sm4 v-if="item.tipo === 'Uso de combustível'">
                <v-select
                  :items="plano"
                  filled
                  v-model="idplano"
                  item-text="descricao"
                  item-value="id"
                  label="Plano"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm6 v-if="tipo_cliente === 'PREFEITURA'">
                <v-select
                  :items="fornecedor"
                  filled
                  v-model="idfornecedor"
                  item-text="nome"
                  item-value="id"
                  label="Fornecedor"
                  :rules="rules.fornecedor"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm6 v-if="tipo_cliente === 'PREFEITURA'">
                <v-select
                  :items="depto"
                  filled
                  v-model="iddepto"
                  item-text="descricao"
                  item-value="id"
                  label="Departamento"
                  :rules="rules.depto"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm6>
                <v-select
                  :items="profissional"
                  filled
                  v-model="idprofissional"
                  item-text="nome"
                  item-value="id"
                  label="Motorista"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm6>
                <v-select
                  :items="veiculo"
                  filled
                  v-model="idveiculo"
                  item-text="descricao"
                  item-value="id"
                  label="Veículo"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm6 v-if="tipo_cliente !== 'PREFEITURA'">
                <v-select
                  :items="transportadora"
                  filled
                  v-model="idtransportadora"
                  item-text="descricao"
                  item-value="id"
                  label="Transportadora"
                  :rules="rules.transportadora"
                  @input="onTransportadoraSelect()"
                ></v-select>
              </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn small color="primary" @click="onReportClick" :loading="loading" :disabled="!valid">Gerar Relatório</v-btn>
    </v-card-actions>
  </v-card>
  <v-layout id="formulario-layout-a" row justify-center>
    <v-dialog v-model="dialogLista" persistent max-width="1200px">
      <v-card>
        <v-card-text>
          <v-form v-model="valid">
            <v-container grid-list-md>
              <!-- DATA INICIAL -->
              <h3>Gerando arquivo texto</h3>
              <v-layout row wrap>
                <v-flex xs12 sm2>
                  <v-text-field
                    v-model="documento"
                    label="Documento Fiscal"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm3>
                  <v-text-field
                    v-model="total"
                    label="Total"
                    readonly
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
          <v-container grid-list-md>
            <v-layout column style="height: 500px">
              <v-flex style="overflow: auto">
                <v-data-table
                  v-model="requisicoes"
                  :headers="headers"
                  :items="requisicoesItens"
                  item-key="id"
                  hide-actions
                >
                  <template slot="items" slot-scope="props">
                    <td width="20px">
                      <v-checkbox
                        v-model="props.item.somar"
                        primary hide-details
                      ></v-checkbox>
                    </td>
                    <td>{{ props.item.data_lancto }}</td>
                    <td>{{ props.item.placa }}</td>
                    <td>{{ props.item.plano }}</td>
                    <td>{{ props.item.qtde }}</td>
                    <td>{{ props.item.odometro_anterior }}</td>
                    <td>{{ props.item.valor_unitario }}</td>
                    <td>{{ props.item.valor_total }}</td>
                    <td>{{ props.item.departamento }}</td>
                    <td>{{ props.item.cpf }}</td>
                    <td>{{ props.item.centro_departamento }}</td>
                    <td>{{ props.item.centro_veiculo }}</td>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
        <v-btn small color="primary" @click="geraTxt()">Gerar arquivo TXT</v-btn>
        <v-spacer></v-spacer>
        <v-btn small color="primary" @click="geraRelatorio()">Gerar relatório</v-btn>
        <v-spacer></v-spacer>
        <v-btn small color="primary" @click="somatoria()">Somar</v-btn>
        <v-spacer></v-spacer>
        <v-btn small color="primary" @click="fechar()">Fechar</v-btn>
      </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</div>
</template>
<script>
import { formatDateToBr, formatDateToEn, showError } from '@/utils'
// import { TIPO_RELATORIO_LANCAMENTO_ENUM } from '@/enums'
// import dependenteService from '@/services/dependente'
import relatorioService from '@/services/relatorio'
import profissionalService from '@/services/profissional'
import veiculosService from '@/services/veiculos'
import empresafornecedorService from '@/services/empresa_fornecedor'
import store from '@/store'
import departamentosService from '@/services/departamentos'
import transportadoraService from '@/services/transportadora'
import planoService from '@/services/plano'

export default {
  name: 'relatorios_lancamentos',
  data () {
    return {
      documento: '',
      total: '',
      requisicoesItens: [],
      requisicoes: [],
      headers: [
        { text: 'Somar', value: 'somar', sortable: false },
        { text: 'Data', value: 'data_lancto', sortable: false },
        { text: 'Placa', value: 'placa', sortable: false },
        { text: 'Descrição', value: 'plano', sortable: false },
        { text: 'Quantidade', value: 'qtde', sortable: false },
        { text: 'Km', value: 'odometro_anterior', sortable: false },
        { text: 'Valor Unitário', value: 'valor_unitario', sortable: false },
        { text: 'Valor Total', value: 'valor_total', sortable: false },
        { text: 'Departamento', value: 'departamento', sortable: false },
        { text: 'Motorista', value: 'cpf', sortable: false },
        { text: 'Centro Departamento', value: 'centro_departamento', sortable: false },
        { text: 'Centro Veículo', value: 'centro_veiculo', sortable: false }],
      dialogLista: false,
      plano: [],
      tipo_cliente: '',
      retorno: [],
      mostrar: '',
      idplano: 0,
      idveiculo: 0,
      idprofissional: 0,
      idfornecedor: 0,
      iddepto: 0,
      idtransportadora: 0,
      relatorio: {},
      profissional: [],
      veiculo: [],
      fornecedor: [],
      depto: [],
      transportadora: [],
      valid: false,
      loading: false,
      menuDataInicial: false,
      menuDataFinal: false,
      dataPickerInicial: '',
      dataPickerFinal: '',
      // tipos: TIPO_RELATORIO_LANCAMENTO_ENUM.values,
      tipos: [],
      dependentes: [],
      tipoRelatorio: '',
      dataInicial: '',
      dataFinal: '',
      nomepdf: '',
      item: {
        id_conveniado: '',
        razao_conveniado: '',
        id_associado: '',
        razao_associado: '',
        id_dependente: '',
        id_atividade: '',
        id_cidade: '',
        dataInicial: '',
        dataFinal: '',
        tipo: ''
      },
      rules: {
        dataInicial: [v => !!v || 'Campo Requerido', v => this.checkDateIsValid(v)],
        dataFinal: [v => !!v || 'Campo Requerido', v => this.checkDatesInterval(v)],
        tipo: [v => !!v || 'Campo Requerido'],
        fornecedor: [v => !!v || 'Campo Requerido'],
        depto: [v => !!v || 'Campo Requerido'],
        transportadora: [v => !!v || 'Campo Requerido']
      }
    }
  },
  watch: {
    dataPickerInicial () {
      this.item.dataInicial = formatDateToBr(this.dataPickerInicial)
    },
    dataPickerFinal () {
      this.item.dataFinal = formatDateToBr(this.dataPickerFinal)
    }
  },
  mounted: async function () {
    try {
      this.loading = true
      this.requisicao = {}
      this.profissional = []
      this.veiculo = []
      this.fornecedor = []
      this.depto = []
      this.plano = []
      this.mostrar = false
      this.relatorio.fk_plano = undefined
      this.tipo_cliente = store.tipo_cliente
      if (store.tipo_cliente === 'PREFEITURA') {
        this.tipos.push('Fechamento')
        this.tipos.push('Uso de combustível')
        this.tipos.push('Requisições')
        // this.tipos = ['Fechamento']
      } else {
        this.tipos.push('Viagens Analítico')
        this.tipos.push('Viagens Sintético')
        // this.tipos.push('Médias Km')
        // this.tipos = ['Viagens Analítico'],['Viagens Sintético']
        // this.tipos = ['Viagens Analítico', 'Viagens Sintético']
      }
      this.mostrar = store.tipo
      this.idplano = 0
      this.iddepto = 0
      this.idfornecedor = 0
      this.idcliente = 0
      this.idveiculo = 0
      this.idprofissional = 0
      this.idtransportadora = 0
      // const result = await profissionalService.getAllWithoutPagination()
      const result = await profissionalService.getProfissionaisHabilitados()
      if (result.data === undefined) {
        showError('Não localizei profissionais!!!')
        return
      }
      this.profissional = result.data
      var result1 = await veiculosService.getVeiculosHabilitados()
      if (result1.data === undefined) {
        showError('Não localizei veículos!!!')
        return
      }
      const resultp = await planoService.getByNome('Abastecimento', store.id_empresa)
      // const result = await planoService.getByTipo()
      if (resultp.data !== undefined) {
        this.plano = resultp.data
        // this.plano.push('TODOS')
      }
      this.veiculo = result1.data
      if (store.tipo_cliente === 'PREFEITURA') {
        var result2 = await empresafornecedorService.getByAll()
        if (result2.data === undefined) {
          showError('Não localizei fornecedores!!!')
          return
        }
        this.fornecedor = result2.data
        var result3 = await departamentosService.getByAll()
        if (result3.data === undefined) {
          showError('Não localizei departamentos!!!')
          return
        }
        this.depto = result3.data
        // this.depto.push('TODOS')
      } else {
        var result4 = await transportadoraService.getTransportadorasHabilitadas()
        if (result4.data === undefined) {
          showError('Não localizei transportadoras!!!')
          return
        }
        this.transportadora = result4.data
      }
    } catch (error) {
      showError(error)
    } finally {
      this.loading = false
    }
  },
  methods: {
    async geraRelatorio () {
      var passo = 0
      var codigos = []
      var tudo = {}
      var vt = 0.0
      this.nomepdf = store.nome
      for (passo = 0; passo <= this.requisicoesItens.length - 1; passo++) {
        if (this.requisicoesItens[passo].somar === true) {
          codigos.push(this.requisicoesItens[passo].id)
          vt = vt + parseFloat(this.requisicoesItens[passo].valor_total)
        }
      }
      this.total = vt
      tudo['dataInicial'] = this.dataInicial
      tudo['dataFinal'] = this.dataFinal
      tudo['nomepdf'] = this.nomepdf
      tudo['codigos'] = codigos
      const result = await relatorioService.reportPost(tudo)
      // const result = await relatorioService.reportr(this.dataInicial, this.dataFinal, this.nomepdf, codigos)
      if (result.data.data[0].erro === 'S') {
        showError('Atenção: ' + result[0].path)
      } else {
        window.open(result.data.data[0].path)
      }
    },
    geraTxt () {
      var passo = 0
      var txt = ''
      for (passo = 0; passo <= this.requisicoesItens.length - 1; passo++) {
        if (this.requisicoesItens[passo].somar === true) {
          var vt = this.requisicoesItens[passo].valor_total
          vt = vt.replace('.', '#')
          vt = vt.replace(',', '@')
          vt = vt.replace('#', ',')
          vt = vt.replace('@', '.')
          var vh = this.requisicoesItens[passo].odometro_anterior
          vh = vh.replace('.', '#')
          vh = vh.replace(',', '@')
          vh = vh.replace('#', ',')
          vh = vh.replace('@', '.')
          var vq = this.requisicoesItens[passo].qtde
          vq = vq.replace('.', '#')
          vq = vq.replace(',', '@')
          vq = vq.replace('#', ',')
          vq = vq.replace('@', '.')
          var vu = this.requisicoesItens[passo].valor_unitario
          vu = vu.replace('.', '#')
          vu = vu.replace(',', '@')
          vu = vu.replace('#', ',')
          vu = vu.replace('@', '.')
          // vu = vu.toLocaleString('pt-br', { minimumFractionDigits: 3 })
          txt = txt + this.requisicoesItens[passo].data_lancto + ';' + this.requisicoesItens[passo].plano + ';' + vq + ';' + vu + ';' + vt + ';' + this.documento + ';' + this.requisicoesItens[passo].placa + ';' + vh + ';' + this.requisicoesItens[passo].centro_departamento + ';' + this.requisicoesItens[passo].cpf + ';1\n'
        }
      }
      this.download(txt, 'importa.txt')
    },
    download (content, filename, contentType) {
      if (!contentType) {
        contentType = 'application/octet-stream'
      }
      var a = document.createElement('a')
      var blob = new Blob([content], { 'type': contentType })
      a.href = window.URL.createObjectURL(blob)
      a.download = filename
      a.click()
    },
    somatoria () {
      var tot = 0.0
      var passo = 0
      for (passo = 0; passo <= this.requisicoesItens.length - 1; passo++) {
        if (this.requisicoesItens[passo].somar === true) {
          tot = tot + parseFloat(this.requisicoesItens[passo].valor_total)
        }
      }
      this.total = tot.toFixed(2)
    },
    fechar () {
      this.dialogLista = false
    },
    async onReportClick () {
      this.tipoRelatorio = this.item.tipo
      if (store.tipo_cliente === 'PREFEITURA') {
        if (this.idfornecedor === 0) {
          showError('Selecione um fornecedor!!!')
          return
        }
        if (this.iddepto === 0 && this.tipoRelatorio === 'Fechamento') {
          showError('Selecione um departamento!!!')
          return
        }
        if (this.idplano === 0 && this.item.tipo === 'Uso de combustível') {
          showError('Selecione um plano!!!')
          return
        }
      }
      this.dataInicial = formatDateToEn(this.item.dataInicial)
      this.dataFinal = formatDateToEn(this.item.dataFinal)
      this.nomepdf = store.nome
      try {
        this.loading = true
        if (store.tipo_cliente === 'PREFEITURA') {
          if (this.tipoRelatorio === 'Requisições') {
            // const result = await relatorioService.reportr(this.dataInicial, this.dataFinal, this.nomepdf, this.idfornecedor, this.iddepto)
            const result = await relatorioService.reportela(this.dataInicial, this.dataFinal, this.nomepdf, this.idfornecedor, this.iddepto, this.idprofissional, this.idveiculo)
            if (result[0].erro === 'S') {
              showError('Atenção: ' + result[0].path)
            } else {
              this.requisicoesItens = result[0].lista
              this.total = result[0].total
              this.dialogLista = true
              // window.open(result[0].path)
            }
          } else if (this.tipoRelatorio === 'Fechamento') {
            const result = await relatorioService.report(this.tipoRelatorio, this.dataInicial, this.dataFinal, this.nomepdf, this.idfornecedor, this.idveiculo, this.idprofissional, this.idcliente, this.iddepto, this.idtransportadora)
            if (result[0].erro === 'S') {
              showError('Atenção: ' + result[0].path)
            } else {
              window.open(result[0].path)
            }
          } else {
            const result = await relatorioService.reportv(this.dataInicial, this.dataFinal, this.nomepdf, this.idfornecedor, this.idveiculo, this.idprofissional, this.iddepto, this.idplano)
            if (result[0].erro === 'S') {
              showError('Atenção: ' + result[0].path)
            } else {
              window.open(result[0].path)
            }
          }
        } else {
          const result1 = await relatorioService.reportv(this.tipoRelatorio, this.dataInicial, this.dataFinal, this.nomepdf, this.idfornecedor, this.idveiculo, this.idprofissional, this.idcliente, this.iddepto, this.idtransportadora)
          if (result1[0].erro === 'S') {
            showError('Erro ao gerar relatório: ' + result1[0].path)
          } else {
            window.open(result1[0].path)
          }
        }
      } catch (error) {
        showError(error)
      } finally {
        this.loading = false
      }
    },
    checkDateIsValid (v) { // TODO: helper global
      return true
    },
    checkDatesInterval (v) {
      let dataInicial = Date.parse(formatDateToEn(this.item.dataInicial))
      let dataFinal = Date.parse(formatDateToEn(this.item.dataFinal))
      if (dataInicial > dataFinal) return 'Data Final é maior que Data Inicial'
      return true
    }
  }
}
</script>
